import { ReactNode, PropsWithChildren } from 'react';
import Description from 'src/features/plugins/outlook/components/Feedback/Description';
import Title from 'src/features/plugins/outlook/components/Feedback/Title';
import Action from 'src/features/plugins/outlook/components/Feedback/Action';
import { Card } from 'src/shared/components/ui/card';
import { cn } from 'src/shared/lib/utils';

interface FeedbackProps {
  className?: string;
  Footer?: ReactNode;
  testId?: string;
}

function Feedback({ children, className, Footer, testId }: PropsWithChildren<FeedbackProps>) {
  return (
    <div
      data-testid={testId}
      className="w-[100vw] h-[100vh] flex flex-col justify-center items-center bg-white grid-container"
    >
      <div className="h-full flex flex-col items-center justify-center w-[80%] gap-2">
        <Card className={cn('w-full px-7 pt-6 pb-6', className)}>
          <div className="flex items-center shrink-0 gap-4 mx-auto justify-center mb-4 pr-3 h-[20px]">
            <img
              src="/static/images/tekst-logo.svg"
              width={100}
              height={100}
              alt="Tekst logo"
              className="w-auto h-[18px] mb-2"
            />
          </div>
          {children}
        </Card>
      </div>
      {Footer}
    </div>
  );
}

Feedback.Title = Title;
Feedback.Description = Description;
Feedback.Action = Action;

export default Feedback;
